/**
 * Checks if the current time is within the specified time range.
 *
 * @param {string} startTime - The time range string in the format "hh:mm AM/PM".
 * @param {string} endTime - The time range string in the format "hh:mm AM/PM".
 * @returns {boolean} True if the current time is within the specified range, false otherwise.
 */
export function isTimeEligible(startTime, endTime) {
    if (!(startTime && endTime)) {
        console.error(" start or end times not found");
        return false;
    }

    // if(startTime == "12:00 PM" && endTime ==  "01:00 PM"){
    //     console.log("inside eligibity check");
    // }

    // Get current time
    var currentTime = new Date();
    var currentHours = currentTime.getHours();
    var currentMinutes = currentTime?.getMinutes();
    var currentAMPM = currentHours >= 12 ? "PM" : "AM";

    // Convert current time to 12-hour format
    // currentHours = currentHours % 12;
    // currentHours = currentHours === 0 ? 12 : currentHours; // Handle noon (12 PM) and midnight (12 AM)

    // Check if the current time is within the specified range
    startTime = startTime.split(" ");
    endTime = endTime.split(" ");

    var startHours = parseInt(startTime[0].split(":")[0]);
    var startMinutes = parseInt(startTime[0].split(":")[1]);
    var startAMPM = startTime[1];

    var endHours = parseInt(endTime[0].split(":")[0]);
    var endMinutes = parseInt(endTime[0].split(":")[1]);
    var endAMPM = endTime[1];

    // Convert start and end times to 24-hour format for comparison
    if (startAMPM === "PM" && startHours !== 12) {
        startHours += 12;
    }

    if (endAMPM === "PM" && endHours !== 12) {
        endHours += 12;
    }

    if (
        // (currentAMPM === startAMPM && currentHours > startHours) ||
        (currentAMPM === startAMPM && currentHours < startHours && currentHours < endHours) ||
        (currentAMPM === startAMPM && currentHours === startHours && currentMinutes >= startMinutes) ||
        (currentAMPM === endAMPM && currentHours < endHours) ||
        (currentAMPM === endAMPM && currentHours === endHours && currentMinutes <= endMinutes)
    ) {
        return true;
    } else {
        return false;
    }
};

